import { PrivilegeType } from "../../Enums/ChoiceEnums"

export interface IPatientMultipleCheckInItem {
    appointmentId: number,
    appointmentTime: string,
    appointmentStatus: string,
    resourceName: string,
    locationName: string
    selected?: boolean
}

export interface IPatientMultipleCheckInResults {
    appointmentList:  Array<IPatientMultipleCheckInItem>
}

export interface IPatientMultipleCheckInInputItem {
    appointmentId: number
}

export interface IPatientMultipleCheckInInputs {
    launchAppointmentId: number,
    appointmentList: Array<IPatientMultipleCheckInInputItem>
}

export interface ICheckInOutDashboardSearchInputs {
    scheduleDate: string,
    tabId: CheckInOutDashboardTab,
    filterId?: number
}

export interface ICheckInOutDashboardListItem {
    appointmentId: number,
    patientId: number,
    patientEid: number,
    patientFirstName?: string,
    patientLastName?: string,
    patientBirthDate: string,
    scheduledEntityName: string,
    serviceLocationName: string,
    appointmentStatusId: number,
    appointmentStatus: string,
    appointmentDate: string,
    startTime: string,
    endTime: string,
    resourceId: number,
    resourceEid: number,
    commentGroupId?: number,
    patientName: string,
    ageText?: string,
    gender: string,
    appointmentType?: string
}

export interface ICheckInOutDashboardSelectedRow {
    appointmentId?: number,
    patientId: number,
    patientEid: number,
    patientName: string,
    appointmentDate: string,
    resourceId?: number,
    resourceName?: string,
    serviceLocationName?: string,
    appointmentStatusId?: number,
    commentGroupId?: number
}

export interface ICheckInOutDashboardFilterItem {
    filterId: number,
    description: string,
    tooltip?: string,
    shared: boolean,
    active: boolean,
    defaultFilter: boolean
}

export interface ICheckInOutDashboardAppointmentStatusItem {
    fromStatusId: number,
    fromStatusDescription: string,
    toStatusId?: number,
    toStatusDescription?: string,
    workflowEnabled: boolean
}

export interface IQuickPayTabItem {
    quickPayTabId: QuickPayTabSetup,
    screenName: string,
    title: string,
    label: string,
    enabled: boolean,
    expanded: boolean,
    privilege: PrivilegeType 
}

export interface IQuickPayTabItemEx extends IQuickPayTabItem {
    selectedOnce?: boolean
}

export interface IQuickPayTabList {
    tabList: IQuickPayTabItem[],
    tabType: QuickPayTabType
}

export interface ICheckInOutDashboardUpdateStatusInputs {
    patientId: number,
    appointmentId: number,
    appointmentStatusId: number
}

export interface ICheckInOutDashboardUpdateStatusResult {
    passed: boolean,
    errorMessage?: string,
    alertMessage?: string,
    patientValidationExists: boolean,
    patientValidationMessage?: string,
    groupMessageExists: boolean,
    groupMessage?: string
}

export interface ICheckInOutFilterAppointmentTypeItem {
    appointmentTypeId: number,
    appointmentName: string,
    selected: boolean
}
export interface ICheckInOutFilterAppointmentStatusItem {
    appointmentStatusId: number,
    appointmentStatusDescription: string,
    selected: boolean
}
export interface ICheckInOutFilterAppointmentResourceItem {
    resourceId: number,
    resourceName: string,
    resourceCategory: string,
    selected: boolean
}
export interface ICheckInOutFilterAppointmentGroupItem {
    groupId: number,
    groupIdType: number,
    groupName: string,
    selected: boolean
}
export interface ICheckInOutFilterTypeResult {
    typeList: ICheckInOutFilterAppointmentTypeItem[],
    statusList: ICheckInOutFilterAppointmentStatusItem[],
    resourceList: ICheckInOutFilterAppointmentResourceItem[],
    groupList: ICheckInOutFilterAppointmentGroupItem[]
}

export interface ICheckInOutFilterGroupItem {
    groupId: number,
    groupTypeId: number
}
export interface ICheckInOutDashboardFilterSaveInputs {
    tabId: number,
    filterId?: number,
    description: string,
    tooltip?: string,
    active: boolean,
    shared: boolean,
    defaultFilter: boolean,
    isCopy: boolean,
    typeList?: number[],
    statusList?: number[],
    resourceList?: number[],
    groupList?: ICheckInOutFilterGroupItem[],
}

export interface ICheckInOutDashboardFilterSaveResponse {
    passed: boolean,
    errorMessage?: string,
    filterId?: number
}

export interface ICheckInOutDashboardPassedOnlyResult {
    passed: boolean
}

export interface ICheckInOutDashboardTabResult {
    defaultFilterId?: number,
    rescheduledAppointmentStatusId?: number
}

export interface ICheckInOutDashboardTabSaveItem {
    quickPayTabId: number,
    enabled: boolean,
    expanded: boolean
}

export interface ICheckInOutDashboardTabSaveInputs {
    tabId: number,
    tabList: ICheckInOutDashboardTabSaveItem[],
    tabType: number
}

export interface ICheckInOutDashboardStatusItem {
    fromStatusId: number,
    fromStatusDesc: string,
    toStatusId: number,
    toStatusDesc: string
}

export interface ICheckInOutDashboardStatusWorkflowSaveItem {
    fromStatusId: number,
    toStatusId?: number,
    enabled: boolean
}

export interface ICheckInOutDashboardStatusWorkflowSaveInputs {
    tabId: number,
    statusList: ICheckInOutDashboardStatusWorkflowSaveItem[]
}

export interface ISchedulePatientMultipleCheckInExists {
    multipleExists: boolean
}

export enum CheckInOutDashboardTab {
    CheckIn = 0,
    CheckOut = 1,
    QuickPay = 2
}

export enum QuickPayTabSetup {
    Receipt = 1,
    PatientDemographicsSummary = 2,
    PrintQueue = 3,
    Prescription = 4,
    PatientPhotographInsuranceCards = 5,
    Letters = 6,
    Eligibility = 7,
    Authorizations = 8,
    Intakes = 9,
    Claim = 10,
    Orders = 11
}

export enum QuickPayTabType {
    Dropdown = 0,
    Tab = 1,
}

export enum AppScreenNames {
    ToDoDocReview = "ToDoDocReview.asp",
    User2FA = "User2FA.htm",
    DocumentReconciliation = "DocumentReconciliation",
    UnsolicitedDocumentSetup = "UnsolicitedDocumentSetup",
    CoverMyMedsEpaQueue = "CoverMyMedsEpaQueue", // CoverMyMeds Electronic Prior Auth task Queue
    MMLAdmin = "MMLKey.htm",
    CommentScreen = "CommentScreen.asp",
}

export enum AppointmentStatus {
    Scheduled = 1,
    Confirmed = 2,
    NoShow = 3,
    CheckedIn = 4,
    CheckedOut = 5,
    Cancelled = 6
}

